<template>
  <div>
    <div class="flex flex-wrap items-center gap-2">
      <SecondaryButton
        v-if="merchantInvoiceRequired"
        class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        @click="openModal = true"
      >
        <ReceiptTaxIcon class="w-3 h-3 mr-1 shrink-0" />
        <span class="whitespace-nowrap text-base">Ajouter une facture</span>
      </SecondaryButton>

      <SecondaryButton
        v-if="merchantQuotationRequired"
        class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        @click="openModal = true"
      >
        <DocumentTextIcon class="w-3 h-3 mr-1 shrink-0" />
        <span class="whitespace-nowrap text-base">Ajouter un devis</span>
      </SecondaryButton>
    </div>
    <div class="mt-3">
      <QuotationUploadModal
        v-if="merchantQuotationRequired"
        :open="openModal"
        :claim="claim"
        @close="openModal = false"
      />
      <InvoiceUploadModal
        v-else-if="merchantInvoiceRequired"
        :open="openModal"
        :claim="claim"
        @close="openModal = false"
      />
    </div>
  </div>
</template>

<script>
import { ReceiptTaxIcon, DocumentTextIcon } from "@heroicons/vue/solid";
import InvoiceUploadModal from "@/components/claim/details/information/action/invoices/InvoiceUploadModal.vue";
import QuotationUploadModal from "@/components/claim/details/information/action/quotations/QuotationUploadModal.vue";
import { mapGetters } from "vuex";
import { SecondaryButton } from "@estaly/ui";

export default {
  components: {
    QuotationUploadModal,
    InvoiceUploadModal,
    ReceiptTaxIcon,
    DocumentTextIcon,
    SecondaryButton,
  },

  props: ["claim"],

  data() {
    return {
      openModal: false,
    };
  },

  computed: {
    ...mapGetters("claims", ["merchantQuotationRequired", "merchantInvoiceRequired"]),
  },
};
</script>
